export default __webpack_public_path__ + "static/media/rocket.f44777d5.png";